/**
 * BaseFeature - Abstract base class for all features
 */
export default class BaseFeature {
    constructor(widget, options = {}) {
        this.widget = widget;
        this.options = options;
        this.isActive = false;
    }

    /**
     * Enable the feature - override in subclass
     */
    enable() {
        this.isActive = true;
    }

    /**
     * Disable the feature - override in subclass
     */
    disable() {
        this.isActive = false;
    }

    /**
     * Get feature icon SVG - override in subclass
     */
    getIcon() {
        return null;
    }

    /**
     * Add a CSS class to document body
     */
    addBodyClass(className) {
        document.body.classList.add(className);
    }

    /**
     * Remove a CSS class from document body
     */
    removeBodyClass(className) {
        document.body.classList.remove(className);
    }
}
